import React from 'react';
import styles from './styles.module.css';

const storageKey = 'hide-podcast-banner';

export default () => {
    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        const hideConsultationBanner =
            window.sessionStorage.getItem(storageKey);

        if (hideConsultationBanner === null) {
            setShow(true);
        }
    }, []);

    if (!show) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div />
            <p>
                {'New: Read the latest analysis of the public consultation responses '}
                <a
                    href="https://link.springer.com/article/10.1007/s11096-026-02218-9"
                    target="_blank"
                >
                    {'here'}
                </a>
                {'!'}
            </p>
            <button
                onClick={() => {
                    setShow(false);
                    window.sessionStorage.setItem(storageKey, 'yes');
                }}
                type="button"
            >
                ×
            </button>
        </div>
    );
};
